import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import { getDevToolsConfig } from "config";

import GoogleTagManager from "@redux-beacon/google-tag-manager";
import { ThunkAction, ThunkDispatch, UnknownAction, configureStore } from "@reduxjs/toolkit";
import { createMiddleware } from "redux-beacon";

import createRootReducer from "./reducers";
import { eventsMap } from "../analytics/eventsMap";

const gtm = GoogleTagManager();
const gtmMiddleware = createMiddleware(eventsMap, gtm);

const devTools = getDevToolsConfig();

export const reducer = createRootReducer();
const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(gtmMiddleware),
  devTools,
});

export type RootState = ReturnType<typeof reducer>;
export type AppThunk<T = UnknownAction> = ThunkAction<
  Promise<UnknownAction> | T,
  RootState,
  null,
  UnknownAction
>;

export type AppDispatch = ThunkDispatch<RootState, null, UnknownAction>;
export type Store = typeof store;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
